module.exports = __webpack_public_path__ + "img/top5.9cad7fb2.png";